<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" id="v-card">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Student All Receipts</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <!-- <v-row justify="center" dense>
                  <v-col cols="4">
                      <v-text-field class="padding-bot" color="#0f2027" rounded outlined dense v-model="registration_no" placeholder="Enter Registration No." persistent-hint hint="Registration No." @click="putnull()"></v-text-field>
                  </v-col>
                  <v-btn v-if="registration_no" class="mt-1 button" @click="getReceipts();show=true">Fetch</v-btn>
              </v-row> -->
                <v-row justify="center">
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete v-model="status" rounded return-object @change="putnull();getStud()"
                            :items="status_list" label="Select Status" item-text="name" outlined dense
                            prepend-icon="mdi-account-child-circle"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete rounded :items="academic_year_list" v-model="selected_ay"
                            item-text="academicyear" item-value="ay_id" label="Academic Year" dense outlined
                            @click="putnull()" placeholder="Select Academic Year"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-combobox v-model="registration_no" rounded :items="stud_list" label="Select Student"
                            item-text="name" outlined dense prepend-icon="mdi-account-child-circle"
                            @click="putnull()"></v-combobox>
                    </v-col>
                    <v-btn v-if="registration_no" class="mt-1 button" @click="
          getReceipts();
        show = true;
        ">
                        Fetch
                    </v-btn>
                </v-row>
            </v-card-text>
        </v-card>
        <span v-if="show">
            <v-row justify="center" dense class="box no-display">
                <v-col cols="12" sm="3" md="3" v-if="tenant == 'sbpps' || tenant == 'zeal'">
                    <v-btn small color="error" @click="
          expand = !expand;
        expand2 = false;
        expand3 = false;
        expand4 = false;
         expand5 = false;
        ">
                        Student Tax Receipts
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn small color="error" @click="
          expand2 = !expand2;
        expand = false;
        expand3 = false;
        expand4 = false;
         expand5 = false;
        show_receipts_btn = false;
        " v-if="this.show_fee_btn">
                        Student Fee Receipts
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn small color="error" @click="
          expand3 = !expand3;
        expand2 = false;
        expand = false;
        expand4 = false;
         expand5 = false;
        show_receipts_btn = false;
        " v-if="this.show_misc_btn">
                        Student Misc. Receipts
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="tenant == 'sbpps' || tenant == 'zeal'">
                    <v-btn small color="error" @click="
          expand4 = !expand4;
        expand2 = false;
        expand3 = false;
        expand = false;
         expand5 = false;
        show_receipts_btn = false;
        " v-if="this.show_outstanding_btn">
                        Student Outstanding Receipts
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn small color="error" @click="
          expand5 = !expand5;
          expand = false;
        expand2 = false;
        expand3 = false;
        expand4 = false;
        show_receipts_btn = false;
        " v-if="this.show_fee_btn">
                        Canteen payment receipts
                    </v-btn>
                </v-col>
            </v-row>
            <!-- tax receipt start -->
            <v-expand-transition>
                <v-card class="box" v-show="expand" v-if="student_receipt_details.length > 0" id="v-card">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Student Tax Receipt Details</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br />
                    <v-data-table :headers="headers_1" :items="student_receipt_details" class="elevation-1 mytable"
                        :search="search" dense>
                        <template v-slot:[`item.show`]="{ item }">
                            <v-avatar style size="25" class="edit-avatar"> </v-avatar>
                        </template>
                    </v-data-table>
                    <v-row justify="center" dense>
                        <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                            <v-radio label="Both" value="both" color="#0f2027"></v-radio>
                            <v-radio label="Office Copy" value="office" color="#0f2027"></v-radio>
                            <v-radio label="Student Copy" value="student" color="#0f2027"></v-radio>
                        </v-radio-group>
                        <v-btn small class="mt-3 ml-7 button" @click="showReceipts()">Get Challan</v-btn>
                    </v-row>
                </v-card>
                <v-card class="box" v-show="expand" v-else id="v-card">
                    <span class="text">
                        <center>Student Tax Receipts Not Available</center>
                    </span>
                </v-card>
            </v-expand-transition>
            <!-- tax receipt end -->
            <!-- prev fee receipt start -->
            <v-expand-transition>
                <v-card class="box" v-show="expand2" v-if="student_receipt_details.length > 0" id="v-card">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Student Fee Receipt Details</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br />
                    <v-data-table :items="student_receipt_details" :headers="headers2" class="elevation-1 mytable" dense
                        :search="search">
                        <template v-slot:item.print="{ item }">
                            <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs"
                                        v-on="on" @click="print1(item.receipt_no, item.ay)"> <v-icon
                                            color="warning">mdi-printer</v-icon>Print Receipt</v-btn>
                                </template>
                                <span> Print Fee Receipt!!! </span>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.edit="{ item }">
                            <div>
                                <v-avatar style="" size="25" class="edit-avatar">
                                    <v-icon class="edit-v-icon mr-2" @click="editItemFeeReceipt(item)">edit</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                        <template v-slot:item.delete="{ item }">
                            <div>
                                <!-- delete tax receipt -->
                                <v-avatar style="" size="25" class="delete-avatar">
                                    <v-icon class="delete-v-icon mr-2" @click="showReason(item.id)">delete</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card class="box" v-show="expand2" v-else id="v-card">
                    <span class="text">
                        <center>Student Fee Receipts Not Available</center>
                    </span>
                </v-card>
            </v-expand-transition>
            <!-- prev fee receipt end -->
            <v-expand-transition>
                <v-card class="box" v-show="expand3" v-if="mics_other_fees_student_records != ''">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Student Misc. Receipt Details</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br />
                    <v-data-table v-if="mics_other_fees_student_records.length > 0" dense :headers="headers3"
                        :items="mics_other_fees_student_records" :search="search" class="elevation-1 mytable">
                        <template v-slot:item.action="{ item }">
                            <v-icon color="red" @click="deletedialog(item.id)">mdi-delete-circle</v-icon>
                        </template>
                        <template v-slot:item.print="{ item }">
                            <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs"
                                        v-on="on" @click="print3(item.receipt_no, item.ay)"> <v-icon
                                            color="warning">mdi-printer</v-icon>Print Receipt</v-btn>
                                </template>
                                <span> Print Fee Receipt!!! </span>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.edit="{ item }">
                            <div>
                                <v-avatar style="" size="25" class="edit-avatar">
                                    <v-icon class="edit-v-icon mr-2" @click="editItemMiscReceipt(item)">edit</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card class="box" v-show="expand3" v-else id="v-card">
                    <span class="text">
                        <center>Student Misc. Receipts Not Available</center>
                    </span>
                </v-card>
            </v-expand-transition>
            <!-- Canteen payment receipts start -->
            <v-expand-transition>
                <v-card class="box" v-show="expand5" v-if="canteen_receipts.length > 0" id="v-card">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Canteen payment receipts Details</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br />
                    <v-data-table :items="canteen_receipts" :headers="headers5" class="elevation-1 mytable" dense
                        aria-sort="srno" :search="search">
                        <!-- <template v-slot:item.srno="{ index }">
                            {{ index + 1 }}
                        </template> -->
                        <template v-slot:item.installment="{ item }">
                            <span v-if="item.installment_name">
                                {{ item.installment_name }}
                            </span>
                            <span v-else-if="item.installment_type == 'Monthly'">
                                {{ item.monthly }}
                            </span>
                            <span v-else-if="item.installment_type == 'Datewise'">
                                {{ item.datewise }}
                            </span>
                            <span v-else>
                                -
                            </span>
                        </template>

                        <template v-slot:item.print="{ item }">
                            <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs"
                                        v-on="on" @click="print5(item.receipt_no)"> <v-icon
                                            color="warning">mdi-printer</v-icon>Print Receipt</v-btn>
                                </template>
                                <span> Print Fee Receipt!!! </span>
                            </v-tooltip>
                        </template>
                        <!-- <template v-slot:item.edit="{ item }">
                            <div>
                                <v-avatar style="" size="25" class="edit-avatar">
                                    <v-icon class="edit-v-icon mr-2" @click="editItemFeeReceipt(item)">edit</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                        <template v-slot:item.delete="{ item }">
                            <div>
                                delete tax receipt
                                <v-avatar style="" size="25" class="delete-avatar">
                                    <v-icon class="delete-v-icon mr-2" @click="showReason(item.id)">delete</v-icon>
                                </v-avatar>
                            </div>
                        </template> -->
                    </v-data-table>
                </v-card>
                <v-card class="box" v-show="expand5" v-else id="v-card">
                    <span class="text">
                        <center>Canteen payment receipts Not Available</center>
                    </span>
                </v-card>
            </v-expand-transition>
            <!-- canteen payment receipts end -->
            <v-expand-transition>
                <v-card class="box" v-show="expand4" v-if="student_outstanding_receipts != ''">
                    <v-toolbar v-if="student_outstanding_receipts.length > 0" flat dense class="toolbar" align="center"
                        justify="center">
                        <v-toolbar-title>Student Outstanding Fee Receipts</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                    </v-toolbar>
                    <br />
                    <v-data-table :headers="headers4" :items="student_outstanding_receipts" :search="search"
                        class="elevation-1 mytable" dense v-if="student_outstanding_receipts.length > 0">
                        <template v-slot:item.print="{ item }">
                            <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs"
                                        v-on="on" @click="print4(item.receipt_no, item.ay)"> <v-icon
                                            color="warning">mdi-printer</v-icon>Print Receipt</v-btn>
                                </template>
                                <span> Print Fee Receipt!!! </span>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.edit="{ item }">
                            <div>
                                <v-avatar style="" size="25" class="edit-avatar">
                                    <v-icon class="edit-v-icon mr-2"
                                        @click="editItemOutastndingReceipt(item)">edit</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card class="box" v-show="expand4" v-else id="v-card">
                    <span class="text">
                        <center>Student Outstanding Receipts Not Available</center>
                    </span>
                </v-card>
            </v-expand-transition>
            <v-btn v-if="show_receipt != '' && show_receipts_btn" class="ma-2 no-display info" @click="proceed()">
                Proceed to print </v-btn>
            <v-row v-if="show_receipt != '' && show_receipts_btn" id="print">
                <v-col cols="12" sm="6" md="6" class="m-0 p-0" v-if="radios == 'office'">
                    <v-card>
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <td colspan="3">
                                            <center><strong>Fee Receipt </strong></center>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th v-if="org_basic_data.trust_logo">
                                            <center>
                                                <img :src="org_basic_data.trust_logo" width="50%" alt="logo" />
                                            </center>
                                        </th>
                                        <td>
                                            <center>
                                    <tr v-if="org_basic_data.trust_name">
                                        <strong>{{ org_basic_data.trust_name }}</strong>
                                    </tr>
                                    <tr v-if="org_basic_data.school_name">
                                        <strong>{{ org_basic_data.school_name }} </strong>
                                    </tr>
                                    <tr v-if="org_basic_data.address">
                                        {{ org_basic_data.address }}
                                    </tr>
                                    <tr v-if="org_basic_data.phone">
                                        Phone : {{ org_basic_data.phone }}
                                    </tr>
                                    <tr v-if="org_basic_data.email">
                                        Email : {{ org_basic_data.email }}
                                    </tr>
                                    <tr v-if="org_basic_data.website">
                                        Website : {{ org_basic_data.website }}
                                    </tr>
                                    </center>
                                    </td>
                                    <th v-if="org_basic_data.school_logo">
                                        <center>
                                            <img :src="org_basic_data.school_logo" width="50%" alt="logo" />
                                        </center>
                                    </th>
                                    </tr>
                                    <!-- <tr>
                                      <td colspan="3">PRN No. : {{show_receipt.registration_number}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Name : {{show_receipt.name}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Office Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Fee Details For : {{show_receipt.ay}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Standard : {{show_receipt.standard}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">
                                          Receipt Date : {{show_receipt.receipt_date}}
                                      </td>
                                  </tr> -->
                                    <tr>
                                        <td colspan="1">
                                            PRN No. : {{ show_receipt.registration_number }}
                                        </td>
                                        <td colspan="1">Student Name : {{ show_receipt.name }}</td>
                                        <td colspan="1">Office Copy</td>
                                    </tr>
                                    <tr>
                                        <td colspan="1">Fee Details For : {{ show_receipt.ay }}</td>
                                        <td colspan="1">Standard : {{ show_receipt.standard }}</td>
                                        <td colspan="1">
                                            Receipt Date : {{ show_receipt.receipt_date }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><strong>Fee Type</strong></td>
                                        <td><strong> Fee Amount (Rs.)</strong></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in show_receipt.component_list_tax_receipt" :key="item.id">
                                        <td colspan="2">
                                            {{ item.feescomponentacademicyear_name }}
                                        </td>
                                        <td>{{ item.fee_amount }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <strong>Total Fee Amount</strong>
                                        </td>
                                        <td>{{ show_receipt.total_fees_amount }}.00</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <v-row dense class="ml-2">
                                                <strong> Amount In Words : </strong>
                                                {{ toWords(show_receipt.total_fees_amount) }}
                                            </v-row>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <v-row dense class="ml-2">
                                                <strong>Installment Wise Details</strong>
                                            </v-row>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <v-simple-table dense class="elevation-1">
                                                <thead>
                                                    <tr>
                                                        <td>
                                                            <center>No.</center>
                                                        </td>
                                                        <td>
                                                            <center>Receipt No.</center>
                                                        </td>
                                                        <td>
                                                            <center>Receipt Date</center>
                                                        </td>
                                                        <td>
                                                            <center>Amount Paid</center>
                                                        </td>
                                                        <td>
                                                            <center>Transaction ID </center>
                                                        </td>
                                                        <td>
                                                            <center>Payment Mode</center>
                                                        </td>
                                                        <!-- <td>
                                                            <center>Fine</center>
                                                        </td> -->
                                                    </tr>
                                                </thead>
                                <tbody>
                                    <tr v-for="(item, index ) in show_receipt.student_receipt_details" :key="item.id">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ item.receipt_no }}</td>
                                        <td>{{ item.receipt_date }}</td>
                                        <td>{{ item.amount }}</td>
                                        <td>{{ item.trans_id }}</td>
                                        <td>{{ item.payment_mode_name }}</td>
                                        <!-- <td>{{ item.fine }}</td> -->
                                    </tr>
                                </tbody>
                        </v-simple-table>
                        </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <v-row class="ml-2 mt-2"><strong>Note : </strong></v-row>
                                <v-row class="ml-2">1. Fee once paid will not be refundable</v-row>
                                <v-row class="ml-2">2. Late fee will have to be paid applicable</v-row>
                                <v-row class="ml-2">3. Receipt should be produced any time if required for
                                    verification</v-row>
                                <v-row class="ml-2 mb-2">4. This is computer generated receipt no signature
                                    required</v-row>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <strong>
                                    <center></center>
                                </strong>
                            </td>
                            <td>
                                <strong>
                                    <center></center>
                                </strong>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <strong>
                                    <center>Accounts Officer</center>
                                </strong>
                            </td>
                            <td>
                                <strong>
                                    <center>Seal</center>
                                </strong>
                            </td>
                        </tr>
                        </tbody>
</template>
</v-simple-table>
</v-card>
</v-col>
<v-col cols="12" sm="8" md="8" class="m-0 p-0 table-container" v-if="radios == 'student'">
    <v-card class="table-container" v-if="show_receipt != ''">
        <!-- <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn> -->
        <v-simple-table dense class="elevation-1 table-container">
            <template v-slot:default>
                <thead>
                    <tr>
                        <td colspan="3">
                            <center><strong>Fee Receipt </strong></center>
                        </td>
                    </tr>
                    <tr>
                        <th v-if="org_basic_data.trust_logo">
                            <center>
                                <img :src="org_basic_data.trust_logo" width="40%" alt="logo" />
                            </center>
                        </th>
                        <td>
                            <center>
                    <tr v-if="org_basic_data.trust_name">
                        <strong>{{ org_basic_data.trust_name }}</strong>
                    </tr>
                    <tr v-if="org_basic_data.school_name">
                        <strong>{{ org_basic_data.school_name }} </strong>
                    </tr>
                    <tr v-if="org_basic_data.address">
                        {{ org_basic_data.address }}
                    </tr>
                    <tr v-if="org_basic_data.phone">
                        Phone : {{ org_basic_data.phone }}
                    </tr>
                    <tr v-if="org_basic_data.email">
                        Email : {{ org_basic_data.email }}
                    </tr>
                    <tr v-if="org_basic_data.website">
                        Website : {{ org_basic_data.website }}
                    </tr>
                    </center>
                    </td>
                    <th v-if="org_basic_data.school_logo">
                        <center>
                            <img :src="org_basic_data.school_logo" width="60%" alt="logo" />
                        </center>
                    </th>
                    </tr>
                    <!-- <tr>
                                      <td colspan="3">PRN No. : {{show_receipt.registration_number}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Name : {{show_receipt.name}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Fee Details For : {{show_receipt.ay}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Standard : {{show_receipt.standard}}</td>
                                  </tr> 
                                  <tr>
                                      <td colspan="3">
                                          Receipt Date : {{show_receipt.receipt_date}}
                                      </td>
                                  </tr> -->
                    <tr>
                        <td colspan="1">
                            PRN No. : {{ show_receipt.registration_number }}
                        </td>
                        <td colspan="1">Student Name : {{ show_receipt.name }}</td>
                        <td colspan="1">Student Copy</td>
                    </tr>
                    <tr>
                        <td colspan="1">Fee Details For : {{ show_receipt.ay }}</td>
                        <td colspan="1">Standard : {{ show_receipt.standard }}</td>
                        <td colspan="1">
                            Receipt Date : {{ show_receipt.receipt_date }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2"><strong>Fee Type</strong></td>
                        <td><strong> Fee Amount (Rs.)</strong></td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in show_receipt.component_list_tax_receipt" :key="item.id">
                        <td colspan="2">
                            {{ item.feescomponentacademicyear_name }}
                        </td>
                        <td>{{ item.fee_amount }}</td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <strong>Total Fee Amount</strong>
                        </td>
                        <td>{{ show_receipt.total_fees_amount }}.00</td>
                    </tr>

                    <tr>
                        <td colspan="3">
                            <v-row dense class="ml-2">
                                <strong> Amount In Words : </strong>
                                {{ toWords(show_receipt.total_fees_amount) }}
                            </v-row>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <v-row dense class="ml-2">
                                <strong>Installment Wise Details</strong>
                            </v-row>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <v-simple-table dense class="elevation-1">
                                <thead>
                                    <tr>
                                        <td>
                                            <center>No.</center>
                                        </td>
                                        <td>
                                            <center>Receipt No.</center>
                                        </td>
                                        <td>
                                            <center>Receipt Date</center>
                                        </td>
                                        <td>
                                            <center>Amount Paid</center>
                                        </td>
                                        <td>
                                            <center>Transaction ID </center>
                                        </td>
                                        <td>
                                            <center>Payment Mode</center>
                                        </td>

                                        <!-- <td>
                                            <center>Fine</center>
                                        </td> -->
                                    </tr>
                                </thead>
                <tbody>
                    <tr v-for="(item, index) in show_receipt.student_receipt_details" :key="item.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.receipt_no }}</td>
                        <td>{{ item.receipt_date }}</td>
                        <td>{{ item.amount }}</td>
                        <td>{{ item.trans_id }}</td>
                        <td>{{ item.payment_mode_name }}</td>

                        <!-- <td>{{ item.fine }}</td> -->
                    </tr>
                </tbody>
        </v-simple-table>
        </td>
        </tr>
        <tr>
            <td colspan="3">
                <v-row class="ml-2 mt-2"><strong>Note : </strong></v-row>
                <v-row class="ml-2">1. Fee once paid will not be refundable</v-row>
                <v-row class="ml-2">2. Late fee will have to be paid applicable</v-row>
                <v-row class="ml-2">3. Receipt should be produced any time if required for verification</v-row>
                <v-row class="ml-2 mb-2">4. This is computer generated receipt no signature required</v-row>
            </td>
        </tr>
        <tr>
            <td colspan="2">
                <strong>
                    <center></center>
                </strong>
            </td>
            <td>
                <strong>
                    <center></center>
                </strong>
            </td>
        </tr>
        <tr>
            <td colspan="2">
                <strong>
                    <center>Accounts Officer</center>
                </strong>
            </td>
            <td>
                <strong>
                    <center>Seal</center>
                </strong>
            </td>
        </tr>
        </tbody>
        </template>
        </v-simple-table>
    </v-card>
</v-col>
</v-row>
<v-row v-if="show_receipt != '' && show_receipts_btn && radios == 'both'" id="print">
    <v-col cols="12" sm="6" md="6" class="m-0 p-0">
        <v-card>
            <v-simple-table dense class="elevation-1 table-container">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <td colspan="3">
                                <center><strong>Fee Receipt </strong></center>
                            </td>
                        </tr>
                        <tr>
                            <th v-if="org_basic_data.trust_logo">
                                <center>
                                    <img :src="org_basic_data.trust_logo" width="50%" alt="logo" />
                                </center>
                            </th>
                            <td>
                                <center>
                        <tr v-if="org_basic_data.trust_name">
                            <strong>{{ org_basic_data.trust_name }}</strong>
                        </tr>
                        <tr v-if="org_basic_data.school_name">
                            <strong>{{ org_basic_data.school_name }} </strong>
                        </tr>
                        <tr v-if="org_basic_data.address">
                            {{ org_basic_data.address }}
                        </tr>
                        <tr v-if="org_basic_data.phone">
                            Phone : {{ org_basic_data.phone }}
                        </tr>
                        <tr v-if="org_basic_data.email">
                            Email : {{ org_basic_data.email }}
                        </tr>
                        <tr v-if="org_basic_data.website">
                            Website : {{ org_basic_data.website }}
                        </tr>
                        </center>
                        </td>
                        <th v-if="org_basic_data.school_logo">
                            <center>
                                <img :src="org_basic_data.school_logo" width="50%" alt="logo" />
                            </center>
                        </th>
                        </tr>
                        <!--  <tr>
                                      <td colspan="3">PRN No. : {{show_receipt.registration_number}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Name : {{show_receipt.name}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Office Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Fee Details For : {{show_receipt.ay}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Standard : {{show_receipt.standard}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">
                                          Receipt Date : {{show_receipt.receipt_date}}
                                      </td>
                                  </tr> -->
                        <tr>
                            <td colspan="1">
                                PRN No. : {{ show_receipt.registration_number }}
                            </td>
                            <td colspan="1">Student Name : {{ show_receipt.name }}</td>
                            <td colspan="1">Office Copy</td>
                        </tr>
                        <tr>
                            <td colspan="1">Fee Details For : {{ show_receipt.ay }}</td>
                            <td colspan="1">Standard : {{ show_receipt.standard }}</td>
                            <td colspan="1">
                                Receipt Date : {{ show_receipt.receipt_date }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"><strong>Fee Type</strong></td>
                            <td><strong> Fee Amount (Rs.)</strong></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in show_receipt.component_list_tax_receipt" :key="item.id">
                            <td colspan="2">
                                {{ item.feescomponentacademicyear_name }}
                            </td>
                            <td>{{ item.fee_amount }}</td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <strong>Total Fee Amount</strong>
                            </td>
                            <td>{{ show_receipt.total_fees_amount }}.00</td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <v-row dense class="ml-2">
                                    <strong> Amount In Words : </strong>
                                    {{ toWords(show_receipt.total_fees_amount) }}
                                </v-row>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <v-row dense class="ml-2">
                                    <strong>Installment Wise Details</strong>
                                </v-row>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <v-simple-table dense class="elevation-1">
                                    <thead>
                                        <tr>
                                            <td>
                                                <center>No.</center>
                                            </td>
                                            <td>
                                                <center>Receipt No.</center>
                                            </td>
                                            <td>
                                                <center>Receipt Date</center>
                                            </td>
                                            <td>
                                                <center>Amount Paid</center>
                                            </td>
                                            <td>
                                                <center>Transaction ID </center>
                                            </td>
                                            <td>
                                                <center>Payment Mode</center>
                                            </td>
                                            <!-- <td>
                                                <center>Fine</center>
                                            </td> -->
                                        </tr>
                                    </thead>
                    <tbody>
                        <tr v-for="(
                            item, index
                          ) in show_receipt.student_receipt_details" :key="item.id">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.receipt_no }}</td>
                            <td>{{ item.receipt_date }}</td>
                            <td>{{ item.amount }}</td>
                            <td>{{ item.trans_id }}</td>
                            <td>{{ item.payment_mode_name }}</td>
                            <!-- <td>{{ item.fine }}</td> -->
                        </tr>
                    </tbody>
            </v-simple-table>
            </td>
            </tr>
            <tr>
                <td colspan="3">
                    <v-row class="ml-2 mt-2"><strong>Note : </strong></v-row>
                    <v-row class="ml-2">1. Fee once paid will not be refundable</v-row>
                    <v-row class="ml-2">2. Late fee will have to be paid applicable</v-row>
                    <v-row class="ml-2">3. Receipt should be produced any time if required for verification</v-row>
                    <v-row class="ml-2 mb-2">4. This is computer generated receipt no signature required</v-row>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <strong>
                        <center></center>
                    </strong>
                </td>
                <td>
                    <strong>
                        <center></center>
                    </strong>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <strong>
                        <center>Accounts Officer</center>
                    </strong>
                </td>
                <td>
                    <strong>
                        <center>Seal</center>
                    </strong>
                </td>
            </tr>
            </tbody>
            </template>
            </v-simple-table>
        </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="6" class="m-0 p-0 table-container">
        <v-card class="table-container" v-if="show_receipt != ''">
            <!-- <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn> -->
            <v-simple-table dense class="elevation-1 table-container">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <td colspan="3">
                                <center><strong>Fee Receipt </strong></center>
                            </td>
                        </tr>
                        <tr>
                            <th v-if="org_basic_data.trust_logo">
                                <center>
                                    <img :src="org_basic_data.trust_logo" width="50%" alt="logo" />
                                </center>
                            </th>
                            <td>
                                <center>
                        <tr v-if="org_basic_data.trust_name">
                            <strong>{{ org_basic_data.trust_name }}</strong>
                        </tr>
                        <tr v-if="org_basic_data.school_name">
                            <strong>{{ org_basic_data.school_name }} </strong>
                        </tr>
                        <tr v-if="org_basic_data.address">
                            {{ org_basic_data.address }}
                        </tr>
                        <tr v-if="org_basic_data.phone">
                            Phone : {{ org_basic_data.phone }}
                        </tr>
                        <tr v-if="org_basic_data.email">
                            Email : {{ org_basic_data.email }}
                        </tr>
                        <tr v-if="org_basic_data.website">
                            Website : {{ org_basic_data.website }}
                        </tr>
                        </center>
                        </td>
                        <th v-if="org_basic_data.school_logo">
                            <center>
                                <img :src="org_basic_data.school_logo" width="50%" alt="logo" />
                            </center>
                        </th>
                        </tr>
                        <!--  <tr>
                                      <td colspan="3">PRN No. : {{show_receipt.registration_number}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Name : {{show_receipt.name}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Fee Details For : {{show_receipt.ay}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Standard : {{show_receipt.standard}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">
                                          Receipt Date : {{show_receipt.receipt_date}}
                                      </td>
                                  </tr> -->
                        <tr>
                            <td colspan="1">
                                PRN No. : {{ show_receipt.registration_number }}
                            </td>
                            <td colspan="1">Student Name : {{ show_receipt.name }}</td>
                            <td colspan="1">Student Copy</td>
                        </tr>
                        <tr>
                            <td colspan="1">Fee Details For : {{ show_receipt.ay }}</td>
                            <td colspan="1">Standard : {{ show_receipt.standard }}</td>
                            <td colspan="1">
                                Receipt Date : {{ show_receipt.receipt_date }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"><strong>Fee Type</strong></td>
                            <td><strong> Fee Amount (Rs.)</strong></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in show_receipt.component_list_tax_receipt" :key="item.id">
                            <td colspan="2">
                                {{ item.feescomponentacademicyear_name }}
                            </td>
                            <td>{{ item.fee_amount }}</td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <strong>Total Fee Amount</strong>
                            </td>
                            <td>{{ show_receipt.total_fees_amount }}.00</td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <v-row dense class="ml-2">
                                    <strong> Amount In Words : </strong>
                                    {{ toWords(show_receipt.total_fees_amount) }}
                                </v-row>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <v-row dense class="ml-2">
                                    <strong>Installment Wise Details</strong>
                                </v-row>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <v-simple-table dense class="elevation-1">
                                    <thead>
                                        <tr>
                                            <td>
                                                <center>No.</center>
                                            </td>
                                            <td>
                                                <center>Receipt No.</center>
                                            </td>
                                            <td>
                                                <center>Receipt Date</center>
                                            </td>
                                            <td>
                                                <center>Amount Paid</center>
                                            </td>
                                            <td>
                                                <center>Transaction ID </center>
                                            </td>
                                            <td>
                                                <center>Payment Mode</center>
                                            </td>
                                            <!-- <td>
                                                <center>Fine</center>
                                            </td> -->
                                        </tr>
                                    </thead>
                    <tbody>
                        <tr v-for="(
                            item, index
                          ) in show_receipt.student_receipt_details" :key="item.id">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.receipt_no }}</td>
                            <td>{{ item.receipt_date }}</td>
                            <td>{{ item.amount }}</td>
                            <td>{{ item.trans_id }}</td>
                            <td>{{ item.payment_mode_name }}</td>
                            <!-- <td>{{ item.fine }}</td> -->
                        </tr>
                    </tbody>
            </v-simple-table>
            </td>
            </tr>
            <tr>
                <td colspan="3">
                    <v-row class="ml-2 mt-2"><strong>Note : </strong></v-row>
                    <v-row class="ml-2">1. Fee once paid will not be refundable</v-row>
                    <v-row class="ml-2">2. Late fee will have to be paid applicable</v-row>
                    <v-row class="ml-2">3. Receipt should be produced any time if required for verification</v-row>
                    <v-row class="ml-2 mb-2">4. This is computer generated receipt no signature required</v-row>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <strong>
                        <center></center>
                    </strong>
                </td>
                <td>
                    <strong>
                        <center></center>
                    </strong>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <strong>
                        <center>Accounts Officer</center>
                    </strong>
                </td>
                <td>
                    <strong>
                        <center>Seal</center>
                    </strong>
                </td>
            </tr>
            </tbody>
            </template>
            </v-simple-table>
        </v-card>
    </v-col>
</v-row>
</span>
<v-dialog v-model="dialog_edit_fee" max-width="1000px">
    <v-card>
        <v-col cols="12" sm="12" md="12">
            <edit-fee-receipt :key="render" :payment_mode_list="payment_mode_list" :ay="selected_ay"
                @changedialog="chnaged($event)"></edit-fee-receipt>
        </v-col>
        <v-row justify="center" dense>
            <v-btn class="button mt-3" @click="dialog_edit_fee = false">Cancel</v-btn>
        </v-row>
    </v-card>
</v-dialog>
<v-dialog v-model="dialog_edit_misc_fee" max-width="1000px">
    <v-card>
        <v-col cols="12" sm="12" md="12">
            <edit-misc-receipt v-if="dialog_edit_misc_fee" :payment_mode_list="payment_mode_list"
                @changedialog="chnagedm($event)">
            </edit-misc-receipt>
        </v-col>
        <v-row justify="center" dense>
            <v-btn class="button mt-3" @click="dialog_edit_misc_fee = false">Cancel</v-btn>
        </v-row>
    </v-card>
</v-dialog>
<v-dialog v-model="dialog_edit_outstanding_fee" max-width="1000px">
    <v-card>
        <v-col cols="12" sm="12" md="12">
            <edit-outstanding-receipt :payment_mode_list="payment_mode_list"
                @changedialog="chnagedo($event)"></edit-outstanding-receipt>
        </v-col>
        <v-row justify="center" dense>
            <v-btn class="button mt-3" @click="dialog_edit_outstanding_fee = false">Cancel</v-btn>
        </v-row>
    </v-card>
</v-dialog>
<v-dialog v-model="show_reason" max-width="1000px">
    <v-card>
        <v-toolbar class="toolbar no-display" flat dense>
            <v-toolbar-title>
                <strong> Add Remark </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab small color="white" outlined icon @click="show_reason = false"><v-icon> mdi-close
                </v-icon></v-btn>
        </v-toolbar>
        <v-row dense justify="center">
            <v-col cols="12" sm="6" md="6">
                <p><b>Remark</b></p>
                <v-textarea outlined name="input-7-4" v-model="addRemark" label="Enter Remark"> </v-textarea>
            </v-col>
        </v-row>
        <!-- receipt id-{{ receipt_id }} <br /> -->
        <center>
            <strong>Are you sure you want Delete this Receipt???</strong>
        </center>
        <v-row justify="center">
            <v-btn class="button" text @click="show_reason = false">No</v-btn>
            <v-btn class="button" text :disabled="addRemark != '' ? false : true"
                @click="deleteReceipt(addRemark)">Yes</v-btn>
        </v-row>
    </v-card>
</v-dialog>
</div>
</template>
<script>
    import Receipt from "../../Fees/Receipt";
    import EditFeeReceipt from "./EditFeeReceipt";
    import EditOutstandingReceipt from "./EditOutstandingReceipt";
    import EditMiscReceipt from "./EditMiscReceipt";
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        name: "EditFeeReceipt",
        components: {
            "edit-fee-receipt": EditFeeReceipt,
            "edit-misc-receipt": EditMiscReceipt,
            "edit-outstanding-receipt": EditOutstandingReceipt,
            Receipt,
            Breadcrumbs
        },
        data: () => ({
            headers_1: [
                { text: "Sr. No.", value: "srno" },
                { text: "Receipt No", value: "receipt_no" },
                { text: "Amount", value: "amount" },
                { text: "Fine", value: "fine" },
                { text: "Date", value: "receipt_date" },
                { text: "Transaction ID", value: "trans_id" },
                { text: "Payment Mode", value: "payment_mode_name" },
                // { text: "Actions", value: "show", sortable: false },
            ],
            headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "Name", value: "name" },
                { text: "Academic Year", value: "academicyear" },
                { text: "Standard", value: "standard" },
                { text: "Division", value: "division" },
                { text: "Actions", value: "action", sortable: false },
            ],
            headers2: [
                { text: "Sr. No.", value: "srno", sortable: true },
                { text: "Receipt No", value: "receipt_no", sortable: true },
                { text: "Amount", value: "amount", sortable: true },
                { text: "Fine", value: "fine", sortable: true },
                { text: "Date", value: "receipt_date", sortable: true },
                { text: "Payment Mode", value: "payment_mode_name", sortable: true },
                { text: "Remark", value: "remark", sortable: true },
                { text: "Print Receipt", value: "print", sortable: true },
                { text: "Edit Receipt", value: "edit", sortable: true },
                { text: "Delete Receipt", value: "delete", sortable: true },
            ],
            headers3: [
                { text: "Sr. No.", value: "srno", sortable: false },
                { text: "Student Name", value: "stud_name", sortable: false },
                { text: "PRN No.", value: "prn_no", sortable: false },
                { text: "Class", value: "standard", sortable: false },
                { text: "Div", value: "division", sortable: false },
                { text: "Exam Name", value: "exam_name", sortable: false },
                { text: "Payment Mode", value: "payment_mode", sortable: false },
                { text: "Payment Date", value: "paidon", sortable: false },
                { text: "Receipt No.", value: "receipt_no", sortable: false },
                { text: "Remark", value: "remark", sortable: false },
                {
                    text: "Amount to be collected",
                    value: "ammount_to_collected",
                    sortable: false,
                },
                { text: "Amount Paid", value: "ammount_paid", sortable: false },
                { text: "Remaining", value: "remaining_amount", sortable: false },
                { text: "Edit Receipt", value: "edit", sortable: false },
                { text: "Print Receipt", value: "print", sortable: false },
            ],
            headers4: [
                { text: "Sr. No.", value: "srno" },
                { text: "PRN No.", value: "registration_number" },
                { text: "Name", value: "name" },
                { text: "For Academic Year", value: "of_ay" },
                { text: "Standard", value: "standard" },
                { text: "Quota", value: "quota" },
                { text: "Stream", value: "stream" },
                { text: "Receipt No", value: "receipt_no" },
                { text: "Receipt Date", value: "receipt_date" },
                { text: "Transaction Date", value: "trxn_date" },
                { text: "Remark", value: "remark" },
                { text: "Amount", value: "amount" },
                { text: "Payment Mode", value: "payment_mode" },
                { text: "Edit Receipt", value: "edit", sortable: true },
                { text: "Print Receipt", value: "print", sortable: true },
            ],
            headers5: [
                { text: "Sr. No.", value: "srno", sortable: true },
                { text: "Receipt No", value: "receipt_no", sortable: true },
                { text: "Standard", value: "standard", sortable: true },
                { text: "Division", value: "division", sortable: true },
                { text: "Amount", value: "amount", sortable: true },
                // { text: "Fine", value: "fine", sortable: true },
                { text: "Date", value: "receipt_date", sortable: true },
                { text: "Payment Mode", value: "paymentmode", sortable: true },
                { text: "Installment", value: "installment", sortable: true },
                { text: "Remark", value: "remark", sortable: true },
                { text: "Print Receipt", value: "print", sortable: true },
                // { text: "Edit Receipt", value: "edit", sortable: true },
                // { text: "Delete Receipt", value: "delete", sortable: true },
            ],
            mics_other_fees_student_records: [],
            student_outstanding_receipts: [],
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: false,
            registration_no: "",
            learnerDivisions_list: [],
            student_receipt_details: [],
            canteen_receipts: [],
            dialog_edit_fee: false,
            dialog_edit_misc_fee: false,
            dialog_edit_outstanding_fee: false,
            edit_fee_receipt: null,
            edit_misc_fee_receipt: null,
            edit_outstanding_fee_receipt: null,
            show_receipt: "",
            receipt_date: null,
            new_receipt: true,
            radios: null,
            render: 0,
            expand: false,
            expand2: false,
            expand3: false,
            expand4: false,
            expand5: false,
            show_receipts_btn: false,
            show_fee_btn: false,
            show_misc_btn: false,
            show_outstanding_btn: false,
            show: false,
            academic_year_list: [],
            selected_ay: [],
            stud_list: [],
            payment_mode_list: [],
            org_basic_data: [],
            org_id: null,
            tenant: null,
            show_reason: false,
            //   extraBreadcrumbItems: [


            //   ],
            //   breadcrumbClass: "breadcrumb-style1",
            receipt_id: "",
            addRemark: "",
            status_list: null,
            status: null,
        }),
        methods: {

            toWords(n) {
                const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
                const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
                const w = (num) =>
                    num < 20 ? a[num] :
                        num < 100 ? b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '') :
                            num < 1000 ? a[Math.floor(num / 100)] + ' Hundred ' + (num % 100 ? w(num % 100) : '') :
                                num < 100000 ? w(Math.floor(num / 1000)) + ' Thousand ' + (num % 1000 ? w(num % 1000) : '') :
                                    num < 10000000 ? w(Math.floor(num / 100000)) + ' Lakh ' + (num % 100000 ? w(num % 100000) : '') :
                                        w(Math.floor(num / 10000000)) + ' Crore ' + (num % 10000000 ? w(num % 10000000) : '');

                return w(n) + ' Rupees Only';
            },
            showReason(item) {
                this.show_reason = true;
                this.receipt_id = item;
                const formData = {
                    receipt_id: item,
                };
                console.log("formdata", formData);
                // reason_for_delete
            },

            deleteReceipt(remark) {
                const formData = {
                    reason_for_delete: remark,
                    receipt_id: this.receipt_id,
                };
                axios
                    .post("/AccountingAndFeesReports/deleteFeeReceipt", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Student Fee Receipt deleted successfully");
                            this.getReceipts();
                        }
                        this.show_reason = false;
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => { });
            },
            // deleteItem(item) {
            //     const formData = {
            //         receipt_id: item,
            //     };
            //     axios
            //         .post("/AccountingAndFeesReports/deleteFeeReceipt", formData)
            //         .then((res) => {
            //             if (res.data.flag == "YES") {
            //                 this.showSnackbar("#4caf50", "Student Fee Receipt deleted successfully");
            //                 this.getReceipts();
            //             }
            //         })
            //         .catch((error) => {
            //             window.console.log(error);
            //         })
            //         .finally(() => {
            //         });
            // },
            chnaged(dialog) {
                this.dialog_edit_fee = dialog;
                this.edit_fee_receipt = null
                this.getReceipts();
            },
            chnagedm(dialog) {
                this.dialog_edit_misc_fee = dialog;
                this.getReceipts();
            },
            chnagedo(dialog) {
                this.dialog_edit_outstanding_fee = dialog;
                this.getReceipts();
            },
            editItemFeeReceipt(item) {
                this.render++;
                this.edit_fee_receipt = null
                this.dialog_edit_fee = true;
                this.edit_fee_receipt = item;
                this.$store.commit("setreceipt_data", this.edit_fee_receipt);
            },
            editItemMiscReceipt(item) {
                this.dialog_edit_misc_fee = true;
                this.edit_misc_fee_receipt = { ...item };
                this.$store.commit("setreceipt_data", this.edit_misc_fee_receipt);
            },
            editItemOutastndingReceipt(item) {
                this.dialog_edit_outstanding_fee = true;
                this.edit_outstanding_fee_receipt = item;
                this.$store.commit("setreceipt_data", this.edit_outstanding_fee_receipt);
            },
            putnull() {
                (this.student_receipt_details = []), (this.show_receipt = "");
                (this.mics_other_fees_student_records = []), (this.student_outstanding_receipts = []);
                (this.canteen_receipts = []),
                    this.show = false;
            },
            convert(number) {
                var converter = require("number-to-words");
                const string = converter.toWords(number);
                const string1 = string.charAt(0).toUpperCase() + string.slice(1);
                return string1;
            },
            print1(receipt_no, ay) {
                this.receipt_no = receipt_no;
                this.dialog_print = true;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(this.registration_no.registration_number));
                // this.$router.push({
                //     name: "student-fees-receipts",
                // });
                this.org_id = localStorage.getItem("EPS-tenant");
                // alert(this.org_id)
                if (this.org_id == "wws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-wws",
                    });
                    window.open(routeData.href, "_blank");
                }
                if (this.org_id == "uwws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-uwws",
                    });
                    window.open(routeData.href, "_blank");
                }
                if (this.org_id == "sanjivani") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-sanjivani",
                    });
                    window.open(routeData.href, "_blank");
                }
                if (this.org_id == "vvp") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-vvp",
                    });
                    window.open(routeData.href, "_blank");
                }
                if (this.org_id == "zeal") {
                    let routeData = this.$router.resolve({ name: "zeal-student-receipt" });
                    window.open(routeData.href, "_blank");
                } else {
                    let routeData = this.$router.resolve({ name: "student-fees-receipts" });
                    window.open(routeData.href, "_blank");
                }
            },
            print3(receipt_no, ay) {
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(this.registration_no.registration_number));
                // this.$router.push({
                //     name: "misc-other-exam-fees-payment-receipt",
                // });
                let routeData = this.$router.resolve({
                    name: "misc-other-exam-fees-payment-receipt",
                });
                window.open(routeData.href, "_blank");
            },
            print4(receipt_no, ay) {
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(this.registration_no.registration_number));
                // this.$router.push({
                //     name: "student-outstanding-payment-receipt",
                // });
                let routeData = this.$router.resolve({
                    name: "student-outstanding-payment-receipt",
                });
                window.open(routeData.href, "_blank");
            },
            print5(receipt_no) {
                // alert("print5=====" + receipt_no);
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                // this.$session.set("ay", JSON.stringify(ay));
                // this.$session.set("registration_no", JSON.stringify(this.registration_no.registration_number));
                // this.$router.push({
                //     name: "misc-other-exam-fees-payment-receipt",
                // });
                let routeData = this.$router.resolve({
                    name: "canteen-receipt",
                });
                window.open(routeData.href, "_blank");
            },
            //   print() {
            //       this.$store.state.drawer = false;
            //       let that = this;
            //       window.onafterprint = function () {
            //           that.$store.state.drawer = true;
            //       };
            //       setTimeout(function () {
            //           window.print();
            //       }, 100);
            //   },
            proceed() {
                localStorage.setItem("mics_other_fees_student_records", JSON.stringify(this.mics_other_fees_student_records));
                localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                localStorage.setItem("student_outstanding_receipts", JSON.stringify(this.student_outstanding_receipts));
                localStorage.setItem("show_receipt", JSON.stringify(this.show_receipt));
                localStorage.setItem("radios", JSON.stringify(this.radios));
                localStorage.setItem("show_receipts_btn", JSON.stringify(this.show_receipts_btn));
                let routeData = this.$router.resolve({ name: "tax-fees-receipt-print" });
                window.open(routeData.href, "_blank");
            },
            showReceipts() {
                //this.receipt_date = item.receipt_date;
                const formData = {
                    ay: this.selected_ay,
                    registration_no: this.registration_no.registration_number,
                };
                axios
                    .post("/AccountingAndFeesReports/showReceipts", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.show_receipt = res.data.details;
                            this.show_receipts_btn = true;
                            this.org_basic_data = res.data.org_basic_data;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            getReceipts() {
                const formData = {
                    ay_id: this.selected_ay,
                    registration_no: this.registration_no.registration_number,
                };
                axios
                    .post("/AccountingAndFeesReports/getReceipts", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.student_receipt_details = res.data.student_receipt_details;
                            this.mics_other_fees_student_records = res.data.mics_other_fees_student_records;
                            this.student_outstanding_receipts = res.data.student_receipts;
                            this.payment_mode_list = res.data.payment_mode_list;
                            this.org_basic_data = res.data.org_basic_data;
                            this.canteen_receipts = res.data.canteen_receipts.map((item, index) => ({
                                ...item,
                                srno: index + 1
                            }));
                            //  this.show_receipts_btn = true;
                            this.show_fee_btn = true;
                            this.show_misc_btn = true;
                            this.show_outstanding_btn = true;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.status);
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            onload() { },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStud() {
                this.registration_no = null
                this.stud_list = this.status.stud_list
            },
        },
        mounted() {
            //alert("this.s3url:"+this.s3url)
            axios
                .post("/FeesStructureInstallment/getdata")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.academic_year_list = res.data.aylist;
                        this.selected_ay = res.data.current_ay;
                        this.status_list = res.data.all_stud_list;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        created() {
            this.tenant = localStorage.getItem("EPS-tenant");
        },
    };
</script>
<style scoped>
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    .mytable2 /deep/ thead th {
        background: #0f2027 !important;
        /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
        /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
        /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }

    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }

    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {

        td,
        th {
            display: table-cell !important;
            font-size: small;
        }

        td+td,
        th+th {
            width: auto;
            font-size: small;
        }
    }

    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }

    @media print {
        .element::-webkit-scrollbar {
            width: 0 !important;
        }

        header,
        footer,
        nav,
        date {
            display: none !important;
            overflow-x: hidden;
        }

        table,
        td,
        tr {
            break-inside: avoid-page;
        }

        img {
            width: 100% !important;
        }

        body,
        tr,
        th,
        td {
            font-size: large !important;
            font-weight: bold !important;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        @page {
            size: A4 landscape;
            margin-top: none;
            padding-top: none;
            /* size: 20.5in 15.5in; */
            size: 20.5in 19in;

            overflow-x: hidden;
            /* margin: 0; */
        }

        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: 0.3rem !important;
            font-size: large !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
            overflow-x: hidden;
            overflow-y: hidden;
        }
    }

    .table-container {
        overflow-x: hidden;
        overflow: hidden;
    }

    .text {
        color: red !important;
        font-size: bold !important;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }

    input[type="date"] {
        width: 100%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
</style>